"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classnames = _interopRequireDefault(require("classnames"));

var NotificationCenterItemSkeleton = function NotificationCenterItemSkeleton(_ref) {
  var setRef = _ref.setRef,
      isShown = _ref.isShown;
  return (0, _preact.h)("div", {
    className: (0, _classnames.default)('notification-center__item notification-center__item--skeleton', {
      'is-shown': isShown
    }),
    ref: function ref(node) {
      setRef === null || setRef === void 0 ? void 0 : setRef(node);
    }
  }, (0, _preact.h)("div", {
    className: "notification-center__item__avatar"
  }), (0, _preact.h)("div", {
    className: "notification-center__item__content"
  }, (0, _preact.h)("div", {
    className: "notification-center__item__description-loader"
  }), (0, _preact.h)("div", {
    className: "notification-center__item__time-loader"
  })), (0, _preact.h)("div", {
    className: "notification-center__item__mark-wrapper"
  }));
};

var _default = NotificationCenterItemSkeleton;
exports.default = _default;